import styles from './styles.module.scss';

export interface IContextMenuItemProps {
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const ContextMenuItem = ({ text, icon, onClick }: IContextMenuItemProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === ' ') {
      onClick();
    }
    event.stopPropagation();
  };

  return (
    <div
      tabIndex={0}
      onKeyDown={handleKeyDown}
      aria-label={text}
      onClick={onClick}
      className={styles.contextMenuItem}
      role='menuitem'
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default ContextMenuItem;
